import { formatDuration, intervalToDuration } from "date-fns";

export function formatDays(days: number): string {
  if (days < 1) {
    const hours = Math.round(days * 24);
    if (hours < 1) {
      return `${Math.round(days * 24 * 60)}m`;
    }
    return formatDuration({ hours });
  }
  const totalSeconds = Math.round(days * 86400);
  const duration = intervalToDuration({ start: 0, end: totalSeconds * 1000 });
  return formatDuration(duration, { format: ["days", "hours"] });
}
